import { Form } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import ProductOriginalId from "../ProductOriginalId";

interface ProductOriginalIdFieldProps {}

const ProductOriginalIdField: React.FC<ProductOriginalIdFieldProps> = function (props) {
    const skuPropertiesValue = Form.useWatch("skuPropertiesValue");
    const orderItemTitleValue = Form.useWatch("orderItemTitleValue");
    const { skuKeys, skuKey } = skuPropertiesValue || {};
    const { productKeys, productKey } = orderItemTitleValue || {};

    const disabled = Boolean(skuKeys?.length || productKeys?.length || skuKey || productKey);

    return <ProductOriginalId disabled={disabled} />;
};

export default observer(ProductOriginalIdField);
